import { loadData, saveData, deleteData } from "src/utils/sessionStorage";
import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT } from "../Auth/actionType";

const loginInfo = loadData("loginInfo");

const isValidToken = (token) => {
	return token && typeof token === 'string' && token.trim().length >= 20;
};

const initState = {
    isAuth: loginInfo && isValidToken(loginInfo.token) ? true : false,
    isLoading: false,
    isLoggedIn: false,
    isError: false,
    token: (loginInfo && isValidToken(loginInfo.token)) ? loginInfo.token : "",
    errorMessage: ""
}
export const authReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case LOGIN_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false,
                isLoggedIn: false
            }
        case LOGIN_SUCCESS:
			if (!payload || !payload.token || typeof payload.token !== 'string' || payload.token.trim().length === 0) {
				return {
					...state,
					isLoading: false,
					isError: true,
					errorMessage: 'Invalid token received',
					token: "",
					isLoggedIn: false
				};
			}
            saveData("loginInfo", payload)
            return {
                ...state,
                isLoading: false,
                isAuth: true,
                token: payload.token,
                isLoggedIn: false
            }
        case LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                errorMessage: payload.errMessage,
                token: "",
                isLoggedIn:  payload.isLoggedIn !== undefined ?  payload.isLoggedIn : false
            }
        case LOGOUT:
            deleteData("loginInfo")
            deleteData("currentNav")
            return {
                ...state,
                isLoading: false,
                isAuth: false,
                isError: false,
                isLoggedIn: false
            }
        default:
            return state
    }
}